import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  &:first-child {\n    margin-left: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  path {\n    ",
        "\n  }\n  &:hover path {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { Box, IconButton } from "@miro-site/core";
import theme from "./theme";
/* Social buttons */ import { Twitter, Facebook, LinkedIn, Instagram, Youtube } from "@miro-site/core";
var icons = {
    Twitter: /*#__PURE__*/ _jsx(Twitter, {}),
    Facebook: /*#__PURE__*/ _jsx(Facebook, {}),
    LinkedIn: /*#__PURE__*/ _jsx(LinkedIn, {}),
    Instagram: /*#__PURE__*/ _jsx(Instagram, {}),
    Youtube: /*#__PURE__*/ _jsx(Youtube, {})
};
var Social = styled(Box).attrs({
    as: "ul",
    $styles: {
        display: "flex",
        justifyContent: [
            "center",
            "center",
            "",
            "",
            ""
        ]
    },
    $mt: theme.footer.social.margin.top,
    $mb: theme.footer.social.margin.bottom
}).withConfig({
    componentId: "sc-1122841d-0"
})(_templateObject());
var SocialItem = styled(Box).attrs({
    as: "li",
    $ml: theme.footer.socialItem.margin.left
}).withConfig({
    componentId: "sc-1122841d-1"
})(_templateObject1());
var IconLink = styled(IconButton).withConfig({
    componentId: "sc-1122841d-2"
})(_templateObject2(), function(param) {
    var _$theme = param.theme;
    return _$theme.normalizeStyles({
        transition: "fill ease ".concat(_$theme.animation.transitionDuration)
    });
}, function(param) {
    var _$theme = param.theme;
    return _$theme.normalizeStyles({
        fill: _$theme.colors.outspoken
    });
});
var FooterSocial = function(props) {
    var items = props.items;
    return /*#__PURE__*/ _jsx(Social, {
        children: items.map(function(item, index) {
            return /*#__PURE__*/ _jsx(SocialItem, {
                children: /*#__PURE__*/ _jsx(IconLink, {
                    icon: icons[item.title],
                    label: item.title,
                    href: item.path,
                    title: item.title
                })
            }, index);
        })
    });
};
export default FooterSocial;
